<script lang="ts">
  import { ThemeToggle } from '@shared/ui/theme';
  import { Link } from '@shared/ui/link';
  import { page } from '$app/stores';
  import { DirectusImage, Preset } from '@do/svelte-directus-images';

  $: image = $page.data.configurations.logo;
</script>

<header class="bg-default-50 dark:bg-store-dark sticky top-0 z-20 w-auto transition-transform duration-1000">
  <nav class="font max-w-content mx-auto px-5 text-2xl md:px-8 xl:px-12 2xl:px-0">
    <ul class="grid h-[64px] grid-cols-[1fr_auto_1fr] items-center gap-2 md:h-[72px]">
      <Link props="{{ href: '', class: 'block h-[28px] justify-self-center col-start-2' }}">
        <DirectusImage
          imageData="{image}"
          alt="{image.title}"
          imgClasses="w-auto h-full object-contain dark:invert"
          attributes="{{
            draggable: false,
          }}"
          pictureSizes="{{ default: '200px' }}"
          presetKeys="{Preset.Thumbnail}"
        />
      </Link>

      <li class="col-start-3 flex items-center justify-end gap-10">
        <ThemeToggle />
      </li>
    </ul>
  </nav>
</header>
